import { render, staticRenderFns } from "./ComboUser.vue?vue&type=template&id=7c258f8b&scoped=true&"
import script from "./ComboUser.ts?vue&type=script&lang=ts&"
export * from "./ComboUser.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c258f8b",
  null
  
)

export default component.exports
import {QTable,QSpace,QInput,QIcon,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QSpace,QInput,QIcon,QTr,QTd}, component.options.components || {})
